import Navbar from "@/components/landing/Navbar";
import DiagnosticHero from "@/components/diagnostic/DiagnosticHero";

import MethodIntro from "@/components/landing/MethodIntro";
import Challenge from "@/components/landing/Challenge";
import Solution from "@/components/landing/Solution";
import BrandwayElite from "@/components/landing/BrandwayElite";
import Deliverables from "@/components/landing/Deliverables";
import ServiceExamples from "@/components/landing/ServiceExamples";
import IndustryCarousel from "@/components/landing/IndustryCarousel";

import KeyBenefits from "@/components/landing/KeyBenefits";
import ServiceBonuses from "@/components/landing/ServiceBonuses";
import ServiceGuarantee from "@/components/landing/ServiceGuarantee";
import ServicePricing from "@/components/landing/ServicePricing";
import AboutUs from "@/components/landing/AboutUs";
import Stats from "@/components/landing/Stats";
import Testimonials from "@/components/landing/Testimonials";
import PowerQuote from "@/components/landing/PowerQuote";
import FAQ from "@/components/landing/FAQ";

import ClosingCTA from "@/components/landing/ClosingCTA";
import Footer from "@/components/landing/Footer";
import WhatsAppButton from "@/components/landing/WhatsAppButton";

const Index = () => {
  return (
    <main className="min-h-screen bg-background">
      <Navbar />
      {/* 1) HERO */}
      <DiagnosticHero />
      {/* 2) ¿Tu negocio creció pero tu marca se quedó atrás? */}
      <ClosingCTA />
      {/* 3) Tu marca ya tiene trayectoria */}
      <Challenge />
      {/* 4) Arquitectura de Reputación */}
      <Solution />
      {/* 5) ¿Qué es Brandway? */}
      <BrandwayElite />
      {/* 6) La infraestructura de tu nueva autoridad */}
      <Deliverables />
      {/* 7) Portfolio Multisectorial */}
      <IndustryCarousel />
      {/* 8) Beneficios Clave */}
      <KeyBenefits />
      {/* 9) Bonus */}
      <ServiceBonuses />
      {/* 10) 1000 empresarios */}
      <MethodIntro />
      {/* 11) Casos de éxito */}
      <ServiceExamples />
      {/* 12) Testimonios */}
      <Testimonials />
      {/* 13) Quiénes Somos */}
      <AboutUs />
      {/* 15) Alcance / Trayectoria */}
      <Stats />
      
      {/* 17) Inversión */}
      <ServicePricing />
      {/* 18) Garantía */}
      <ServiceGuarantee />
      {/* 19) Power Quote cierre */}
      <PowerQuote />
      {/* FAQ */}
      <FAQ />
      {/* Footer */}
      <Footer />
      <WhatsAppButton />
    </main>
  );
};

export default Index;
